import React from "react"
import { Switch, Route, withRouter } from "react-router-dom"
import axios from "axios"
import { toast } from "react-toastify"
import { ToastContainer } from "react-toastify"
import Oidc from "oidc-client"
import "react-toastify/dist/ReactToastify.css"

import NavBar from "./components/NavBar"
import ApplicationForm from "./components/ApplicationForm"
import ApplicationPrint from "./components/ApplicationPrint"
import AuthenticationCallback, { Config } from "./Auth"
import Welcome from "./components/Welcome"

let UserManager = new Oidc.UserManager(Config)

class App2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isAuthenticated: false,
      isAuthorized: false,
      user: {},
      isFinal: false,
      working: false,
      loading: false
    }
  }

  async login() {
    await UserManager.signinRedirect()
  }

  async logout() {
    await UserManager.signoutRedirect()
    await UserManager.removeUser()
  }

  changeIsFinal = () => {
    this.setState({ isFinal: true })
  }

  componentDidMount() {
    UserManager.getUser().then((user) => {
      if (user) {
        if (user.profile.FakType !== "1") {
          this.props.history.push("/")
          toast.error("H υποβόλη είναι μόνο για το στρατιωτικό προσωπικού.")
        } else {
          // if (
          //   user.profile.sub !== "ilias.gravvanis@haf.gr" &&
          //   user.profile.sub !== "ioannis.stratis@haf.gr"
          // ) {
          //   this.props.history.push("/")
          //   this.setState({
          //     isAuthenticated: true,
          //     isAuthorized: false,
          //     user: user
          //   })
          //   return toast.error("Δεν έχετε δικαίωμα πρόσβασης στην εφαρμογή.")
          // }
          this.setState({ loading: true })
          axios
            .get(Config.checkApi, {
              headers: {
                Authorization: `Bearer ${user.access_token}`
              }
            })
            .then((res) => {
              this.setState({
                isAuthenticated: true,
                isAuthorized: true,
                user: user,
                isFinal: res.data.isFinal,
                working: res.data.working,
                loading: false
              })
            })
            .catch((error) => {
              toast.error("Αποτυχία μεταφοράς δεδομένων", {
                position: "bottom-right",
                autoClose: 6000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
              })
            })
        }
      }
    })
  }

  render() {
    const { user, isAuthenticated, isAuthorized, isFinal, working, loading } =
      this.state

    return (
      <>
        <NavBar
          user={user}
          login={this.login}
          logout={this.logout}
          isAuthenticated={isAuthenticated}
        />
        <Switch>
          <Route
            path="/callback"
            component={() => (
              <AuthenticationCallback UserManager={UserManager} />
            )}
          />
          <Route
            path="/application"
            component={() => <ApplicationForm user={user} />}
          />
          <Route
            path="/report"
            component={() => <ApplicationPrint user={user} isFinal={isFinal} />}
          />
          <Route
            exact
            path="/"
            component={() => (
              <Welcome
                loading={loading}
                login={this.login}
                isAuthorized={isAuthorized}
                isAuthenticated={isAuthenticated}
                isFinal={isFinal}
                working={working}
              />
            )}
          />
        </Switch>
        <ToastContainer />
      </>
    )
  }
}
export default withRouter(App2)
